var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "magnifier",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#0071B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.046,1.868c-18.748,0-34,15.252-34,34c0,18.748,15.252,34,34,34c18.748,0,34-15.252,34-34 C94.046,17.121,78.794,1.868,60.046,1.868z M60.046,61.868c-14.336,0-26-11.663-26-26c0-14.336,11.664-26,26-26 c14.337,0,26,11.664,26,26C86.046,50.205,74.383,61.868,60.046,61.868z M29.336,60.807l5.682,5.633L10.887,90.782 c-1.556,1.567-4.088,1.578-5.656,0.024c-1.568-1.555-1.579-4.087-0.025-5.655l2.852,2.827l-2.853-2.828L29.336,60.807z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.969e4675bb141516bce26dda60898e51.svg";
export { ForwardRef as ReactComponent };